export function monthOffset(month: string, offset: number) {
  const date = new Date(month + '-01T12:00:00Z'); date.setUTCMonth(date.getUTCMonth() + offset); return date.toISOString().slice(0, 7);
}
export function monthEnd(month: string) {
  const date = new Date(monthOffset(month, 1) + '-01T12:00:00Z'); date.setUTCDate(0); return date.toISOString().slice(0, 10);
}
